import React, { Suspense } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Loading from "./loading/Loading";

const Banner = React.lazy(() => import("./widgets/banner"));
const DescoverWalkin = React.lazy(() => import("./widgets/DescoverWalkin"));
const Showcase = React.lazy(() => import("./widgets/Showcase"));
const Perfectjob = React.lazy(() => import("./widgets/Perfectjob"));
const CompanyList = React.lazy(() => import("./widgets/CompanyList"));
const Feature = React.lazy(() => import("./widgets/feature/Feature"));
const AdvantagesWidgets = React.lazy(() =>
  import("./widgets/advantagesWidgets/AdvantagesWidgets")
);

const Home = () => {
  return (
    <div>
      <Header />
      {/* Suspense provides fallback UI while the components are being loaded */}
      <Suspense fallback={<Loading></Loading>}>
        <Banner />
        
        <DescoverWalkin />
        <AdvantagesWidgets />
        <Feature />
        <Showcase />
      </Suspense>
     \
      <Footer />
    </div>
  );
};

export default Home;
